export default "__VITE_ASSET__BldOVQM2__"